module.exports = __webpack_public_path__ + "img/m_top_game.adeb44ed.jpg";